import { ClientApplicationConfig, FeatureFlags } from '@monorepo/types';
import { useQuery } from '@tanstack/react-query';
import { fetchApplicationConfig } from '../../utils/react-query/query-functions';
import { QUERY_KEYS } from '../../utils/react-query/query-keys';

export const useApplicationConfigQuery = () => {
  return useQuery<ClientApplicationConfig>({
    queryKey: QUERY_KEYS.APP_CONFIG.APPLICATION_CONFIG,
    queryFn: fetchApplicationConfig,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    select: (data) => {
      const featureFlags: FeatureFlags = data.featureFlags ?? {};

      return {
        ...data,
        featureFlags,
      };
    },
  });
};
